    angular.module('account.password-reset', ['account'])
        .controller('AccountResetInitCtrl', function ($scope, Account) {
            $scope.item = {};
            $scope.success = null;
            $scope.error = null;

            $scope.requestReset = function () {
                $scope.error = null;
                $scope.success = null;
                $scope.isSaving = true;
                Account.resetRequest({email: $scope.item.email}, onSuccess, onError);
            };

            var onSuccess = function () {
                $scope.isSaving = false;
                $scope.success = "OK";
            };

            var onError = function () {
                $scope.success = null;
                $scope.isSaving = false;
                $scope.error = true;
            };
        })
        .controller('AccountResetFinishCtrl', function ($scope, $stateParams, toastr, Account) {

            $scope.keyMissing = angular.isUndefined($stateParams.key);
            $scope.doNotMatch = null;
            $scope.error = null;
            $scope.resetAccount = {};
            $scope.success = null;

            $scope.finishReset = function () {
                if ($scope.resetAccount.password !== $scope.resetAccount.confirmPassword) {
                    $scope.doNotMatch = true;
                } else {
                    $scope.success = null;
                    $scope.error = null;
                    $scope.doNotMatch = null;
                    $scope.isSaving = true;
                    Account.resetFinish({
                        key: $stateParams.key,
                        newPassword: $scope.resetAccount.password
                    }, onSuccess, onError);
                }
            };

            var onSuccess = function () {
                $scope.isSaving = false;
                $scope.success = true;
            };

            var onError = function () {
                $scope.success = null;
                $scope.isSaving = false;
                $scope.error = true;
            };
        })
        .config(function ($stateProvider) {
            $stateProvider.state('accountPasswordResetInit', {
                parent: 'unauthenticated',
                url: '/account-reset',
                views: {
                    'content@': {
                        templateUrl: 'app/account/password-reset/reset-init.tpl.html',
                        controller: 'AccountResetInitCtrl'
                    }
                }
            });
            $stateProvider.state('accountPasswordResetFinish', {
                parent: 'unauthenticated',
                url: '/account-reset/finish?key',
                views: {
                    'content@': {
                        templateUrl: 'app/account/password-reset/reset-finish.tpl.html',
                        controller: 'AccountResetFinishCtrl'
                    }
                }
            });
        })
